import React from "react";
import Button from "../../../ui-components/Button";
import Badge from "../../../ui-components/Badge";


const modalOpenerBtn = (value, stateSetterFn) => {
  return <Button
    styleType="empty"
    className="text-xs h-7"
    onClick={(e) => {
      stateSetterFn(value)
      e.stopPropagation()
    }}
  >
    {value.length}
  </Button>
}

export const getColumns = (intl, isManager, lookups, setShowWorksites, setShowSurveys) => {
  let cols = [
    {
      title: intl.formatMessage({id: "name"}),
      field: "name",
      cellStyle: {textTransform: "uppercase", whiteSpace: "nowrap", fontSize: 12},
    },
    {
      title: intl.formatMessage({id: "status"}),
      field: 'status',
      lookup: lookups.status,
      cellStyle: {whiteSpace: "nowrap", textTransform: "uppercase", fontSize: 12}
    },
    {
      title: intl.formatMessage({id: "role"}),
      field: "role",
      lookup: lookups.roles,
      cellStyle: {whiteSpace: "nowrap", textTransform: "uppercase", fontSize: 12}
    },
    {
      title: intl.formatMessage({id: "company"}),
      field: "company",
      cellStyle: {whiteSpace: "nowrap", textTransform: "uppercase", fontSize: 12}
    },
    {
      title: intl.formatMessage({id: "created_worksites"}),
      field: "worksites_created",
      filtering: false,
      render: ({worksites_created}) => <>
        {(worksites_created || []).length
          ? modalOpenerBtn(worksites_created, setShowWorksites)
          : <b className="ml-5">-</b>
        }
      </>
    },
    {
      title: intl.formatMessage({id: "other_worksites"}),
      field: "worksites_shared",
      filtering: false,
      render: ({worksites_shared}) => <>
        {(worksites_shared || []).length
          ? modalOpenerBtn(worksites_shared, setShowWorksites)
          : <b className="ml-1">-</b>
        }
      </>
    },
    {
      title: intl.formatMessage({id: "created_configurations"}),
      field: "surveys",
      filtering: false,
      render: ({surveys}) => surveys?.length > 0
        ? modalOpenerBtn(surveys, setShowSurveys)
        : <b className="ml-1">-</b>
    },
    {
      title: intl.formatMessage({id: "created_at"}),
      field: "created_at",
      defaultSort: "desc",
      render: ({created_at}) => <span>{intl.formatDate(created_at, {
        day: "numeric",
        month: "short",
        year: "numeric"
      })}</span>
    },
  ]

  if (isManager) {
    ['agente_ed', 'agente_pos'].forEach(i => {
      cols.push(
        {
          title: intl.formatMessage({id: i}),
          field: i,
          lookup: lookups.sales,
          render: function (rowData) {
            return rowData[i] ? (
              <div>
                {rowData[i].split(",").map((s) =>
                  s ? <Badge classNames="mb-1 mr-1 text-xxs leading-3" text={lookups.sales[s]} key={s}/> : null
                )}
              </div>
            ) : null;
          },
        })
    })
  }
  return cols
}

export const OPTIONS = {
  filtering: true,
  toolbar: false,
  sorting: true,
  emptyRowsWhenPaging: false,
  pageSize: 10,
  pageSizeOptions: [5, 10, 20, 50],
  headerStyle: {
    fontWeight: "bold",
    fontSize: 13
  },
  filterCellStyle: {paddingTop: 8, maxWidth: 200},
  cellStyle: {textTransform: "uppercase", fontSize: 12},
};

export const LOCALIZATION = {
  header: {
    actions: "",
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} di {count} righe",
    labelRowsSelect: "Righe",
  },
};
